import { AddOrderDto } from '../../../../store/mst/models/RootStore.base';

export enum HeaderColumnKeyEnum {
  ADDRESS = 'address',
  UNIT_NUMBER = 'unitNumber',
  CITY = 'city',
  STATE = 'state',
  ZIP_CODE = 'zipCode',
  COUNTRY = 'country',
  LATITUDE = 'latitude',
  LONGITUDE = 'longitude',
  START_TIME = 'startTime',
  END_TIME = 'endTime',
  NAME = 'name',
  PHONE = 'phone',
  EMAIL = 'email',
  DURATION = 'duration',
  LOAD = 'load',
  INSTRUCTIONS = 'instructions',
  CUSTOM_FIELDS = 'customFields',
  CUSTOMER_ORDER_NUMBER = 'customerOrderNumber',
  DELIVERY_DATE = 'deliveryDate',
  BARCODE = 'barcode',
  TAGS = 'tags',
}

export enum HeaderDataTypeEnum {
  STRING = 'string',
  NUMBER = 'number',
  DATE = 'date',
  TIME = 'time',
}

export enum HeaderNodeTypeEnum {
  OBJECT = 'object',
  ARRAY = 'array',
  ARRAY_OF_OBJECTS = 'arrayOfObjects',
  NONE = '',
}

export type ColumnHeader = {
  columnKey: HeaderColumnKeyEnum | string;
  matchKeys: string[];
  label: string;
  nodePath: keyof AddOrderDto;
  nodeType: HeaderNodeTypeEnum;
  dataType: HeaderDataTypeEnum;
  order: number;
  asyncValidation?: boolean;
  columnWidth?: number;
  customErrorMessage?: string;
  dependsOn?: HeaderColumnKeyEnum;
  isLocationHeader: boolean;
};

export interface HeaderProps {
  locationData: HeaderOption[],
  otherData: HeaderOption[],
}

export interface HeaderOption {
  value: string,
  key: string,
  label: string,
  isSelected: boolean,
  disabled?: boolean,
}
